export default __webpack_public_path__ + "static/media/kingdom-of-colours.fa694201.mp4";